// @flow

import React, { Component } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  ZoomableGroup,
} from "react-simple-maps";
import ReactTooltip from "react-tooltip";

import type { ICPCContest } from "./utils";

const wrapperStyles = {
  width: "100%",
  maxWidth: 980,
  margin: "0 auto",
  cursor: "pointer",
  height: "100%",
  maxHeight: 800,
};

const wrapperStyles_SA = {
  width: "100%",
  maxWidth: 980,
  margin: "0 auto",
  cursor: "pointer",
};

type Props = {
  width: number,
  height: number,
  widthPercent: string,
  heightPercent: string,
  projectionScale: number,
  projectionArray: Array,
  projectionType: string,
  mapCenter: Array,
  map: any,
  toICPCContest: any,
  drawStrokes: boolean,
  contestArea: ?string,

  onSelect?: (regionAbbr: string, regionName: string) => void,
};

type State = {
  hoveredGeo: ?string,
};

class GenericMap extends Component<Props, State> {
  state: State;
  onMouseEnter: (string) => void;
  onMouseLeave: () => void;

  constructor(props: Props) {
    super(props);
    this.state = {
      hoveredGeo: null,
    };
    this.onMouseEnter = this._onMouseEnter.bind(this);
    this.onMouseLeave = this._onMouseLeave.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      ReactTooltip.rebuild();
    }, 100);
  }

  _onMouseEnter(hoveredGeo: string) {
    this.setState({ hoveredGeo });
  }

  _onMouseLeave() {
    this.setState({ hoveredGeo: null });
  }

  handleClick = (contestAbbr: string, contestName: string) => () => {
    if (this.props.onSelect) this.props.onSelect(contestAbbr, contestName);
  };

  render() {
    const {
      width,
      height,
      widthPercent,
      heightPercent,
      projectionScale,
      projectionArray,
      projectionType,
      mapCenter,
      map,
      toICPCContest,
      drawStrokes,
      contestArea,
    } = this.props;
    const toUseWrapperStyle =
      contestArea === "SA" ? wrapperStyles_SA : wrapperStyles;
    return (
      <div style={toUseWrapperStyle}>
        <ComposableMap
          projectionConfig={{
            scale: projectionScale,
            rotation: projectionArray,
          }}
          width={width}
          height={height}
          projection={projectionType}
          style={{ width: widthPercent, height: heightPercent }}
        >
          <ZoomableGroup center={mapCenter} disablePanning>
            <Geographies geography={map} disableOptimization>
              {(geographies, projection) =>
                geographies.map((geography, i) => {
                  let contest: ICPCContest = toICPCContest(
                    geography.properties
                  );
                  let color =
                    this.state.hoveredGeo === contest.name
                      ? contest.colorHovered
                      : contest.color;
                  let lineColor = drawStrokes === true ? "#000000" : color;
                  let darkLinecolor =
                    drawStrokes === true ? "#000000" : contest.colorHovered;
                  return (
                    <Geography
                      key={i}
                      data-tip={contest.name}
                      geography={geography}
                      projection={projection}
                      onClick={this.handleClick(contest.abbr, contest.name)}
                      onMouseEnter={() => this.onMouseEnter(contest.name)}
                      style={{
                        default: {
                          fill: color,
                          stroke: lineColor,
                          strokeWidth: 0.75,
                          outline: "none",
                        },
                        hover: {
                          fill: contest.colorHovered,
                          stroke: darkLinecolor,
                          strokeWidth: 0.75,
                          outline: "none",
                        },
                        pressed: {
                          fill: color,
                          stroke: color,
                          strokeWidth: 0.75,
                          outline: "none",
                        },
                      }}
                    />
                  );
                })
              }
            </Geographies>
          </ZoomableGroup>
        </ComposableMap>
        <ReactTooltip />
      </div>
    );
  }
}

export default GenericMap;
